// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  InputNumber,
  DatePicker,
  Image,// 添加 Image 组件导入
  Upload // 添加Upload组件
} from '@arco-design/web-react';
import { post, get } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';
import { baseUrl } from '../utils';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

interface MenuItem {
  id: number;
  menuName: string;
  menuCode: string;
  menuSort: number;
  isDisplay: number; // 0 or 1
  isSecondPage: number; // 0 or 1
  isHot: number; // 0 or 1
  menuImage: string;
  popupImage: string;
  secondLevelUrl: string; // 新增字段
  updateTime: string;
}

function Clientmenu() {
  const [form] = Form.useForm<MenuItem>();
  const [formSearch] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(false); // 添加全局loading状态
  const formRef = useRef<any>({});
  const [isSecondPageChecked, setIsSecondPageChecked] = useState(false);
  // const URL_UPLOAD = baseUrl + '/sysMenu/uploadImage';
  const URL_UPLOAD = baseUrl + '/common/uploadFile';

  const displayChange = (val: boolean, record: MenuItem, type: string) => {
    const swFlag = val ? 1 : 0;
    setLoading(true); // 设置loading状态

    post(`/sysMenu/update`, { ...record, [type]: swFlag })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false); // 清除loading状态
      });
  };

  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(20);
    getList(true);
  };

  const columns: TableColumnProps[] = [
    {
      title: '序号',
      width: 50,
      render: (_, record, i) => i + 1
    },
    {
      title: '菜单名称',
      dataIndex: 'menuName',
      width: 150
    },
    {
      title: '菜单编码',
      dataIndex: 'menuCode',
      width: 150
    },
    {
      title: '菜单排序',
      dataIndex: 'menuSort',
      width: 100
    },
    {
      title: '是否显示',
      dataIndex: 'isDisplay',
      width: 100,
      render: (text, record) => <Switch checked={text === 1} onChange={val => displayChange(val, record, "isDisplay")} />
    },
    {
      title: '包含二级页',
      dataIndex: 'isSecondPage',
      width: 120,
      render: (text) => <Switch checked={text === 1} disabled />
    },
    {
      title: '二级页地址',
      dataIndex: 'secondLevelUrl',
      width: 150,
      render: (text) => text || '-'
    },
    {
      title: 'isHot',
      dataIndex: 'isHot',
      width: 80,
      render: (text, record) => <Switch checked={text === 1} onChange={val => displayChange(val, record, "isHot")} />
    },
    {
      title: '菜单图片',
      dataIndex: 'menuImage',
      width: 150,
      render: (text) => (text && text.indexOf('http') === 0) ? (
        <Image
          src={text}
          width={50}
          height={50}
          fit="cover"
          preview={true}
          style={{ borderRadius: 4 }}
        />
      ) : '-'
    },
    {
      title: '弹框图片',
      dataIndex: 'popupImage',
      width: 150,
      render: (text) => (text && text.indexOf('http') === 0) ? (
        <Image
          src={text}
          width={50}
          height={50}
          fit="cover"
          preview={true}
          style={{ borderRadius: 4 }}
        />
      ) : '-'
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      width: 180,
      render: text => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      render: (_, record: MenuItem) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)} loading={loading}>
            编辑
          </Button>
          <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
            <Button className="btn" type="text" status="danger" loading={loading}>
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  const getList = (reset?: boolean) => {
    setLoading(true); // 设置loading状态
    if (reset) {
      setPageNum(1);
      setPageSize(20);
    }

    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize
    };

    get('/sysMenu/list', params)
      .then((res: any) => {
        const { list, total } = res.data || {};
        setTotal(total);
        setDataList(list || []);
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false); // 清除loading状态
      });
  };

  const add = () => {
    formRef.current = {};
    setIsSecondPageChecked(false);
    form.resetFields();
    form.setFieldsValue({
      menuImage: '',
      popupImage: ''
    });
    setVisible(true);
  };

  const del = (record: MenuItem) => {
    setLoading(true); // 设置loading状态
    post(`/sysMenu/delete?id=${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false); // 清除loading状态
      });
  };

  const edit = (record: MenuItem) => {
    formRef.current = record;
    const isSecondPageChecked = record.isSecondPage === 1;
    setIsSecondPageChecked(isSecondPageChecked);
    form.setFieldsValue({
      ...record,
      isDisplay: record.isDisplay === 1,
      isSecondPage: record.isSecondPage === 1,
      isHot: record.isHot === 1,
      updateTime: record.updateTime ? dayjs(record.updateTime) : null
    });
    setVisible(true);
  };

  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  const onOk = () => {
    form.validate().then(values => {
      setLoading(true); // 设置loading状态
      const data = {
        ...formRef.current,
        ...values,
        isDisplay: values.isDisplay ? 1 : 0,
        isSecondPage: values.isSecondPage ? 1 : 0,
        isHot: values.isHot ? 1 : 0,
        updateTime: values.updateTime ? dayjs(values.updateTime).format('YYYY-MM-DD HH:mm:ss') : null
      };

      const url = formRef.current.id ? `/sysMenu/update` : `/sysMenu/add`;

      post(url, data)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            Message.success(formRef.current.id ? '编辑成功！' : '新增成功！');
            getList();
            editCancel();
          } else {
            Message.error(message);
          }
        })
        .catch(e => {
          Message.error('网络错误!');
          console.log(e);
        })
        .finally(() => {
          setLoading(false); // 清除loading状态
        });
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="clientmenu table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="菜单名称" field="menuName">
            <Input style={{ width: 200 }} placeholder="请输入菜单名称" />
          </FormItem>
          <FormItem label="是否显示" field="isDisplay">
            <Select style={{ width: 100 }} allowClear placeholder="请选择">
              <Option value={1}>是</Option>
              <Option value={0}>否</Option>
            </Select>
          </FormItem>
          <FormItem label="isHot" field="isHot">
            <Select style={{ width: 100 }} allowClear placeholder="请选择">
              <Option value={1}>是</Option>
              <Option value={0}>否</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <FormItem>
            <Button type="outline"  onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add} loading={loading}>
              新增
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
          loading={loading} // 表格loading状态
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑菜单' : '新增菜单'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading} // 模态框确认按钮loading状态
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="菜单名称" field="menuName" rules={[{ required: true, message: '请输入菜单名称' }]}>
            <Input placeholder="请输入菜单名称" />
          </FormItem>
          <FormItem label="菜单编码" field="menuCode" rules={[{ required: true, message: '请输入菜单编码' }]}>
            <Input placeholder="请输入菜单编码" />
          </FormItem>
          <FormItem label="菜单排序" field="menuSort" rules={[{ required: true, message: '请输入菜单排序' }]}>
            <InputNumber placeholder="请输入菜单排序" style={{ width: '100%' }} min={0} />
          </FormItem>
          <FormItem label="是否显示" field="isDisplay" triggerPropName="checked">
            <Switch />
          </FormItem>
          <FormItem label="包含二级页" field="isSecondPage" triggerPropName="checked">
            <Switch onChange={(checked) => setIsSecondPageChecked(checked)} />
          </FormItem>
          <FormItem label="二级页地址" field="secondLevelUrl">
            <Input
              placeholder="请输入二级页地址"
              disabled={!isSecondPageChecked}
            />
          </FormItem>
          <FormItem label="isHot" field="isHot" triggerPropName="checked">
            <Switch />
          </FormItem>
          <FormItem label="菜单图片" field="menuImage">
            <Upload
              action={URL_UPLOAD}
              headers={{
                'Authorization': `${localStorage.getItem('authToken')}`
              }}
              defaultFileList={form.getFieldValue('menuImage') ? [{ url: form.getFieldValue('menuImage'), uid: '-1', name: 'menuImage' }] : []}
              onChange={(_, file) => {
                if (file?.response?.data) {
                  form.setFieldValue('menuImage', file.response.data);
                }
              }}
              onRemove={() => {
                form.setFieldValue('menuImage', '');
              }}
              limit={1}
              imagePreview
              listType="picture-card"
              multiple={false}
              accept="image/*"
            />
          </FormItem>
          <FormItem label="弹框图片" field="popupImage">
            <Upload
              action={URL_UPLOAD}
              headers={{
                'Authorization': `${localStorage.getItem('authToken')}`
              }}
              defaultFileList={form.getFieldValue('popupImage') ? [{ url: form.getFieldValue('popupImage'), uid: '-1', name: 'popupImage' }] : []}
              onChange={(_, file) => {
                if (file?.response?.data) {
                  form.setFieldValue('popupImage', file.response.data);
                }
              }}
              onRemove={() => {
                form.setFieldValue('popupImage', '');
              }}
              limit={1}
              imagePreview
              listType="picture-card"
              multiple={false}
              accept="image/*"
            />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default Clientmenu;